<script setup>
import { watch } from 'vue';
import { useCallControlSettings } from 'dashboard/composables/useCallControlSettings';
import { useCallControl } from 'dashboard/composables/useCallControl';

const { isEnabled, toggleCallControl } = useCallControlSettings();
const { updateCallControlStatus } = useCallControl();

// Watch para mudanças no isEnabled e enviar para o backend
watch(isEnabled, (newValue) => {
  updateCallControlStatus(newValue);
});
</script>

<template>
  <div class="flex items-center gap-2 w-full">
    <div class="flex-1 truncate">Ligações</div>
    <button
      class="toggle-switch"
      :class="[{ active: isEnabled }]"
      :aria-label="isEnabled ? 'Desativar chamadas' : 'Ativar chamadas'"
      @click.stop="toggleCallControl"
    >
      <span class="toggle-slider" />
    </button>
  </div>
</template>

<style scoped>
.toggle-switch {
  position: relative;
  width: 40px;
  height: 22px;
  background: #ef4444;
  border: none;
  border-radius: 9999px;
  cursor: pointer;
  padding: 0;
  transition: background 0.3s ease;
  flex-shrink: 0;
}

.toggle-switch:hover {
  background: #dc2626;
}

.toggle-switch.active {
  background: #22c55e;
}

.toggle-switch.active:hover {
  background: #16a34a;
}

.toggle-slider {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 18px;
  height: 18px;
  background: white;
  border-radius: 50%;
  transition: transform 0.3s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.toggle-switch.active .toggle-slider {
  transform: translateX(18px);
}
</style>
